module.exports = __webpack_public_path__ + "img/dab_therealms4vr.736c751.png";